import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaExchangeAlt } from "react-icons/fa";

const methodColors = {
  GET: "text-green-600",
  POST: "text-blue-600",
  PUT: "text-amber-600",
  PATCH: "text-orange-600",
  DELETE: "text-red-600",
};

export default function HttpRequestNode({ data, selected }) {
  const method = (data.method || "GET").toUpperCase();

  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[200px] transition-shadow ${
        selected ? "border-cyan-500 shadow-md" : "border-surface-border"
      }`}
    >
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-cyan-500 !border-2 !border-white"
      />

      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-cyan-500">
        <FaExchangeAlt size={10} className="text-white" />
        <span className="text-xs font-semibold text-white">HTTP Request</span>
      </div>

      <div className="px-3 py-2.5">
        {data.url ? (
          <div>
            <span className={`text-xs font-bold ${methodColors[method] || "text-ink-primary"}`}>
              {method}
            </span>
            <p className="text-xs text-ink-primary truncate max-w-[180px] mt-0.5" title={data.url}>
              {data.url}
            </p>
          </div>
        ) : (
          <p className="text-xs text-ink-muted italic">Click to configure request</p>
        )}
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !bg-cyan-500 !border-2 !border-white"
      />
    </div>
  );
}
